import React from 'react'

const ThankYou: React.FC = () => {
    const appUrl = process.env.REACT_APP_LOGIN_PAGE_URL?.trim() || '/login'

    const handleOpenApp = () => {
        window.location.assign(appUrl)
    }

    return (
        <div className="py-5" style={{ minHeight: '70vh', display: 'flex', alignItems: 'center' }}>
            <div className="container">
                <div className="row justify-content-center text-center">
                    <div className="col-md-8 col-lg-6">
                        <img src="/assets/lock.png" alt="success" className="img-fluid mb-4" width="60" />
                        <h1 className="signup__col--title mb-3">Thank you for registering</h1>
                        <p className="signup__col--text mb-4">
                            Your account has been created successfully. Continue to the app when you are ready.
                        </p>
                        <button type="button" className="signup__col--btn" onClick={handleOpenApp}>
                            Go to the app
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ThankYou
